<div [ngClass]="{'import-block__completed': !isActive() && stepState == ImportStepState.Completed, 'import-block__collapsed': !isActive() && stepState == ImportStepState.Available, 'import-block__not-available': stepState <= ImportStepState.NotAvailableYet, 'loading':dataLoading }"
    class="import-block">
    <div class="d-flex align-items-center">
        <div class="number-circle"><span [ngClass]="{'subtitle-2': stepState !== ImportStepState.Completed, 'material-icons-outlined': (stepState === ImportStepState.Completed && !isActive())}">{{
                (stepState === ImportStepState.Completed && !isActive()) ? 'check' : '11' }}</span></div>
        <h4>Forecast</h4>
    </div>
    <ng-container *ngIf="isActive()">
        <div class="body-1 mb-8">Select the periods or categories below to adjust your future {{outcomeName}} forecast dynamically.
            Skip this step if you are not interested in active forecasting.
        </div>
        <div *ngIf="showHint" class="hint-block orange">
            <div class="wrap-text">
                <p class="body-2">
                    The orange-highlighted periods or categories below <b>aren't yet ready</b> for active forecasting because some combinations from your selected dimensions are missing (for example,
                    a specific {{someDimensionName}} might be absent for {{firstNotEligibleControlVal}}).
                </p>
                <p class="body-2">
                    If possible, please return to your source file and <b>add the missing combinations</b>.
                </p>
                <div class="body-2 mt-16">
                    Alternatively, if you choose to proceed and select an orange item, the system will <b>automatically create the missing combinations</b> using the following <b>default values</b> <span *ngIf="haveFormCompAggrTypeAverage">(with averages
                    calculated at the level of each missing combination)</span>:
                    <ul class="mt-8 mb-0">
                        <li *ngFor="let formComp of formCompItems">
                            {{formComp.name}} = {{(formComp.aggregationMethod.type === AggregationType.averageWeighted
                                                                                   ? 'weighted average based on ' + formComp.weightColumnName
                                                                                   : (formComp.aggregationMethod.type === AggregationType.average ? 'average' : 0 )) }}
                        </li>
                    </ul>
                </div>
            </div>
            <a (click)="showHint=false" class="btn-close material-icons-outlined">close</a>
        </div>
        <div>
            <div class="block-series-outer">
                <div class="wrap">
                    <div *ngFor="let row of series; let rowIx = index" [ngClass]="{'block-series':true, 'block-series__red': row.isExclude}">
                        <div class="actions-series d-flex justify-content-between align-items-center">
                            <span class="subtitle-1">{{row.name}}</span>
                            <div *ngIf="row.name == selectedSeriesName && nonExcludedSeriesCount > 1" class="btn-group">
                                <span class="btn btn-text btn-small"><span class="material-icons-outlined">star</span> <span class="subtitle-2">Reference series</span></span>
                            </div>
                        </div>
                        <div class="row-series">
                            <div *ngFor="let item of row.items; let colIx = index" class="cell cell-data on-hover" [ngClass]="{'selected':item && item.isSelectedAsForecast, 'orange':item && !item.isEligibleAsForecast}">
                                <span *ngIf="item && item.isOldControlValue" class="control-left"></span>
                                <span *ngIf="item && item.isNewControlValue" class="control-right"></span>
                                <span *ngIf="item" class="subtitle-1">{{item.controlValue}}</span>
                                <button *ngIf="item && !item.isSelectedAsForecast && item.isCurrentlyEligibleAsForecast" (click)="selectAsForecast(item)" class="btn btn-text btn-small">Select as forecast</button>
                                <button *ngIf="item && item.isSelectedAsForecast" (click)="unSelectAsForecast(item)" class="btn btn-text btn-small">Unselect as forecast</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <button (click)="saveSeries()" [ngClass]="{'loading-small':loading, 'btn':true}">Continue</button>
        </div>
    </ng-container>
    <ng-container *ngIf="!isActive() && stepState == ImportStepState.Completed">
        <div>
            <button (click)="editClick()" class="btn btn-secondary btn-icon btn-edit"><span class="material-icons-outlined">edit</span></button>
        </div>
    </ng-container>
</div>
